// components/CoordinatesInput.tsx
import React from "react";

interface CoordinatesInputProps {
  value: [number | null, number | null];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CoordinatesInput: React.FC<CoordinatesInputProps> = ({ value, onChange }) => {
  return (
    <div className="mb-4 w-full relative">
      <label
        htmlFor="coordinates"
        className="block text-md font-medium text-gray-600 mb-2"
      >
        Input Coordinates or Select from the Map Below
      </label>
      <div className="relative flex gap-6">
        <input
          type="number"
          id="lat"
          name="lat"
          required
          placeholder="Latitude"
          value={value[0] === null ? 0 : value[0].toFixed(2)}
          onChange={onChange}
           className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
        />
        <input
          type="number"
          required
          id="lng"
          name="lng"
          placeholder="Longitude"
          value={value[1] === null ? 0 : value[1].toFixed(2)}
          onChange={onChange}
           className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
        />
      </div>
    </div>
  );
};

export default CoordinatesInput;
